const upperCaseWords = [
  'AI',
  'RAG',
  'ASCII',
  'API',
  'URL',
  'HTML',
  'XML',
  'JSON',
  'CSS',
  'JS',
  'SQL',
  'ID',
  'URL',
  'UI',
  'UX',
  'CDN',
  'SDK',
  'GPT',
];

export function beautifyCamelCaseString(value: string) {
  // Split the string into words, but avoid splitting acronyms in upperCaseWords
  const resultArray = value.replace(/([a-z0-9])([A-Z])/g, '$1 $2').split(' ');
  const resultFixedArray = resultArray
    .map((word) => {
      if (upperCaseWords.includes(word.toUpperCase())) {
        return word.toUpperCase();
      } else {
        return word;
      }
    })
    .join(' ');

  return resultFixedArray.charAt(0).toUpperCase() + resultFixedArray.slice(1);
}
